import { useEffect } from 'react';

/**
 * Hook to redirect HTTP to HTTPS in production
 */
export function useHttpsRedirect() {
  useEffect(() => {
    if (
      window.location.protocol === 'http:' &&
      window.location.hostname !== 'localhost' &&
      !window.location.hostname.startsWith('127.') &&
      !window.location.hostname.startsWith('192.168.')
    ) {
      window.location.href = window.location.href.replace('http:', 'https:');
    }
  }, []);
}
